/* eslint-disable max-classes-per-file */
import { ForsorjningskallaAggregat, ForsorjningskallaTyp } from "~app/common/models/forsorjningskalla";
import { CommandBase, ICommand } from "../../../../common/services/cqs/commandManager";

export class RemoveForsorjningskallaProduktionsomradeCommand extends CommandBase {
    produktionsomradeId: number;
    kundorderradId: number;

    constructor(init: (instance: RemoveForsorjningskallaProduktionsomradeCommand) => void) {
        super("RemoveForsorjningskallaProduktionsomradeCommand");
        init(this);
    }
}

export class RemoveForsorjningskallaTerminalCommand extends CommandBase {
    mottagningsplatsId: number;
    kundorderradId: number;

    constructor(init: (instance: RemoveForsorjningskallaTerminalCommand) => void) {
        super("RemoveForsorjningskallaTerminalCommand");
        init(this);
    }
}

export class RemoveForsorjningskallaLevorderCommand extends CommandBase {
    leverantorsorderradId: number;
    kundorderradId: number;

    constructor(init: (instance: RemoveForsorjningskallaLevorderCommand) => void) {
        super("RemoveForsorjningskallaLevorderCommand");
        init(this);
    }
}

export class RemoveForsorjningskallaCommandFactory {
    static create(
        model: ForsorjningskallaAggregat,
        kundorderradId: number): ICommand {
        switch (model.typ) {
            case ForsorjningskallaTyp.Produktionsomrade:
                return new RemoveForsorjningskallaProduktionsomradeCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.produktionsomradeId = model.id;
                });
            case ForsorjningskallaTyp.Terminal:
                return new RemoveForsorjningskallaTerminalCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.mottagningsplatsId = model.id;
                });
            case ForsorjningskallaTyp.Leverantorsorder:
                return new RemoveForsorjningskallaLevorderCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.leverantorsorderradId = model.id;
                });
            default:
                throw new Error(`Odefinierad typ: ${model.typ}`);
        }
    }
}
